import { render, staticRenderFns } from "./blackList.vue?vue&type=template&id=7bc87510&scoped=true&"
import script from "./blackList.vue?vue&type=script&lang=js&"
export * from "./blackList.vue?vue&type=script&lang=js&"
import style0 from "./blackList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./blackList.vue?vue&type=style&index=1&id=7bc87510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc87510",
  null
  
)

export default component.exports